import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: enTranslation
    },
    fr: {
        translation: frTranslation
    }
};

const options = {
    order: ['querystring', 'cookie'],
    lookupQuerystring: 'lang',
    lookupCookie: 'wp-wpml_current_language',
    cookieMinutes: 10,
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: 'fr',
        lng: 'fr',
        detection: options,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

i18n.changeLanguage();

export default i18n;
